/**
 * @file Accordion
 */
'use strict'

import Common from '../../Utils/Common'

/**
 * @classname Accordion
 * @classdesc アコーディオン
 */
export default class Accordion {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('Accordion.constructor')
		this._$e = $e
		this._$dt = $e.parent('dt')
		console.log('$e.css("display");;' + $e.css('display') )
		this._$isToggle = $e.closest('.dl--accordion').attr('data-slide-toggle')
		this._$dt.on('click', () => this.onClick())
	}

	/**
	 * クリックのコールバック
	 *
	 * @memberof Accordion
	 * @return {undefined}
	 */
	onClick() {
		console.log('Accordion.onClick')
		if(this._$e.css('display') === 'none') {
			return
		}
		if(this._$isToggle) {
			this._$dt.next('dd').slideToggle()
		}
		this._$dt.next('dd').siblings('dd').slideUp()
		this._$dt.toggleClass('open')
		this._$dt.siblings('dt').removeClass('open')
	}
}
